import React, { useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import Header from '../../../components/header/Header'
import styles from '../Rewards.module.scss'
import { categories, coupons, getRandomValue } from '../components/Categories'
import cupomImage from '../../../../assets/images/cupom_de_descontos_logo.png.webp'

export default function Category() {
  const [selectedCoupon, setSelectedCoupon] = useState<string>('')
  const navigate = useNavigate()
  const getcategoryName = () => {
    const categoryId = window.location.pathname.split('/').pop()

    return categories.find(category => category.id === Number(categoryId))?.name
  }

  const getcategoryIcon = () => {
    const categoryId = window.location.pathname.split('/').pop()

    return categories.find(category => category.id === Number(categoryId))?.icon
  }

  const handleCarouselMove = (forward = false) => {
    const carousel = document.querySelector(`.${styles.carousel}`)
    if (!carousel) return
    const couponWidth = 480
    const carouselScroll = forward
      ? carousel.scrollLeft + couponWidth
      : carousel.scrollLeft - couponWidth

    carousel.scrollTo({
      left: carouselScroll > 4000 ? 0 : carouselScroll,
      behavior: 'smooth'
    })
  }

  const handleSelectCoupon = (couponId: string) => {
    if (selectedCoupon === couponId) return
    setSelectedCoupon(couponId)
  }

  return (
    <div className={styles.rewards}>
      <Header />
      <div className={styles.rewardsWrapper}>
        <div className="d-flex flex-column align-items-center justify-content-between mt-2">
          <div
            className={`${styles.category} d-flex flex-column align-items-center`}
          >
            {getcategoryIcon()}
            <h4>{getcategoryName()}</h4>
          </div>
          <hr className="w-100" />
          <ArrowBackIosIcon
            fontSize="large"
            className={styles.arrowBack}
            onClick={() => handleCarouselMove()}
          />
          <ArrowForwardIosIcon
            fontSize="large"
            className={styles.arrowForward}
            onClick={() => handleCarouselMove(true)}
          />
          <div className={styles.carousel}>
            {coupons.map(coupon => (
              <div
                role="presentation"
                key={coupon.id}
                className={`${styles.coupon} ${
                  selectedCoupon === coupon.id ? styles.selected : ''
                } ${selectedCoupon === coupon.id ? styles.fadeIn : ''}`}
                onClick={() => handleSelectCoupon(coupon.id)}
              >
                <img src={cupomImage} alt="imagem do cupom" />
                <h6
                  className={`${styles.discountType}  ${
                    coupon.discountType === 'GRÁTIS'
                      ? styles.free
                      : coupon.discountType.includes('OFF')
                      ? styles.off
                      : styles.pay
                  } `}
                >
                  {coupon.discountType}
                </h6>
                <h6
                  className={`text-center bolder mt-3 ${styles.establishment}`}
                >
                  {coupon.establishment}
                </h6>
                {selectedCoupon === coupon.id && (
                  <div className={styles.couponDetails}>
                    <div className="d-flex justify-content-between">
                      <p className="text-center">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Iste provident dolore eveniet, sint obcaecati reiciendis
                        possimus adipisci, quos, eius tempore labore ea.
                      </p>
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                      <p className="text-center">
                        <strong>Validade:</strong>
                      </p>
                      <p className="text-center">31/12/2026</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="text-center">
                        <strong>Valor mínimo:</strong>
                      </p>
                      <p className="text-center">{`R$ ${getRandomValue(
                        5,
                        10
                      )},00`}</p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="text-center">
                        <strong>Valor máximo:</strong>
                      </p>
                      <p className="text-center">{`R$ ${getRandomValue(
                        11,
                        25
                      )},00`}</p>
                    </div>
                  </div>
                )}
                <div className="d-flex justify-content-center align-items-center mt-4 mb-1">
                  <div
                    className="d-flex align-items-center"
                    style={{ marginLeft: -15 }}
                  >
                    <LocationOnIcon color="error" fontSize="large" />
                    <p style={{ fontSize: 14 }}>{coupon.city}</p>
                  </div>
                </div>
                <div className={styles.button}>
                  <p>
                    {selectedCoupon === coupon.id ? 'RESGATAR' : 'VISUALIZAR'}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/rewards')}
            className="text-center"
            style={{ marginTop: 100 }}
          >
            <ArrowBackIcon fontSize="small" className="me-2" />
            {` VOLTAR`}
          </Button>
        </div>
      </div>
      {selectedCoupon !== '' && (
        <div
          role="presentation"
          onClick={() => setSelectedCoupon('')}
          className={styles.modalBackdrop}
        />
      )}
    </div>
  )
}
